import formatters from 'common/utils/periods.formatters';

class CalendarController {

  constructor($scope, $timeout, $rootScope, AppDictionary) {
    'ngInject';
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.timeout = $timeout;
    this.dictionary = AppDictionary;
  }

  $onInit() {
    this.month = this.date.getMonth();
    this.year = this.date.getFullYear();
    this.options = this._initOptions();
  }

  _initOptions() {
    let dateToInsert = {
      year: this.year,
      month: this.month,
      day: 1,
    };
    let option = {
      displayYear: false,
      todayHighlight: true,
      language: 'es',
      defaultViewDate: dateToInsert,
    };
    if (this.isMobileApp) {
      option.displayYear = true;
    }
    return option;
  }

  onDayRender({ date }) {
    let dayInEvents = this.findDayInEvents(date);
    return formatters.getDayWithContent(date, dayInEvents);
  }

  findDayInEvents(date) {
    let day = this.user.periodInDays.filter((event) => event.day.getTime() === date.getTime());
    return day;
  }

  clicked({ dayClicked, dateDayClicked }) {
    if (this.dayClickedIsRequestDay(dayClicked)) { // Request day
      let day = this.findDayInEvents(dateDayClicked);
      if (day.length === 0) return;
      this.emitRequestDayClickEvent(dayClicked, dateDayClicked, this.user.getPeriodById(day[0].periodId));
    } else { // Day without request
      $('calendar .active').removeClass('active');
      $(dayClicked).addClass('active');
      this.selectDay({ $event: { date: dateDayClicked, inception: !!this.isInception } });
    }
  }

  dayClickedIsRequestDay(dayClicked) {
    return $(dayClicked).hasClass(this.dictionary.getVacation()) || $(dayClicked).hasClass(this.dictionary.getAbsence());
  }

  emitRequestDayClickEvent(dayClicked, dateDayClicked, period) {
    return this.rootScope.$broadcast('REQUEST_DAY_CLICK', { $event: { dayClicked, dateDayClicked, period } });
  }

  hoverOut({ dayHovered }) {
    if (!this.dayClickedIsRequestDay(dayHovered)) return;
    this.rootScope.$broadcast('period-hover-out', {});
  }

  hoverIn({ dayHovered, dateDayHovered }) {
    if (!this.dayClickedIsRequestDay(dayHovered)) return;
    this.rootScope.$broadcast('period-hover-in', {
      dayHovered,
      date: dateDayHovered,
    });
  }
}

export default CalendarController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendar/calendar.controller.js